<template>
    <div class="d-fabs">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'DFabs'
}
</script>

<style lang="scss" scoped>
.d-fabs {
    position: fixed;
    bottom: 30px;
    right: 30px;
    display: flex;
    grid-gap: 15px;
    width: auto;
    z-index: 1050;
    align-items: flex-end;
}
</style>
